<template>
  <div class="home flex-column">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('communication-center') }}</span>
      </div>
    </div>
    <div class="content flex-row">{{ $t('insert-dashboard-content-here') }}</div>
  </div>
</template>

<script>
export default {
  name: 'CCCommunicationCenter',
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    display: flex;
  }
}
.content {
  height: 100%;
  padding-left: 40px;
  flex-wrap: wrap;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 30px 50px 30px 30px;
  justify-content: space-between;
  .right {
    display: flex;
  }
}
</style>
